const { ccclass, property } = cc._decorator;
import BaseTableView from "./base_table_view";
import roadmap from "../../../public/roadmap";
import { EffectName } from "../longhudou_table_effect";
import Util from "../util";

@ccclass
export default abstract class LongHuDouTableView extends BaseTableView {

    @property(cc.Label)
    longCount:cc.Label = null

    @property(cc.Label)
    huCount:cc.Label = null

    @property(cc.Label)
    heCount:cc.Label = null

    @property(cc.Label)
    allCount:cc.Label = null

    
    betAreaType = {
        Long : 1,
        Hu: 2,
        He: 3,
    }

    start(){
        super.start()
        this.tableSound.playBgm()
    }


    //TODO 刷新选择路图
    refreshSelectRoadMap(roadMapDatas){
        super.refreshSelectRoadMap(roadMapDatas)
        this.updateResultCount(this.roadMapDatas)
    }



    updateTopInfo(roomInfo, curRoomStatus){
        super.updateTopInfo(roomInfo, curRoomStatus)
        switch(roomInfo.state){
            case 0: //上庄动画
                break
            case 1: //开始
                break;
            case 2: //洗牌
                this.effectCtr.playEffectAnim(EffectName.XiPai)
                break;
            case 3: // 准备
                this.cleanTable()
                this.bigRound.string = roomInfo.round
                this.effectCtr.playEffectAnim(EffectName.StartVs)
                this.effectCtr.playEffectAnim(EffectName.JuShu)
                this.tableSound.playStartGame()
                break
            case 4: //发牌
                this.scheduleOnce(()=>{
                    this.tableSound.playFanPai()
                   }, 0)
                this.scheduleOnce(()=>{
                    this.tableSound.playFanPai()
                   }, 0.17)
                this.scheduleOnce(()=>{
                    this.tableSound.playFanPai()
                   }, 0.42)
                if (curRoomStatus != null){
                    for (const poker of this.resultPokers) {
                        poker.node.active = true
                    }
                    this.effectCtr.playEffectAnim(EffectName.FaPai)
                }
                this.betDataByIndex = []
                break
            case 5: //下注
                break
            case 6: //开牌
                break
            case 7: //派奖
                break
            default:
                break;
        }

        if (roomInfo.state >= 3 && curRoomStatus == null){
            for (const poker of this.resultPokers) {
                poker.node.active = true
                poker.spriteFrame = this.pokerAtlas.getSpriteFrame(this.paiBeiName)
            }
            this.effectCtr.playEffectAnim(EffectName.FaPai, null, "animation_longhu_fapai_01")
        }
    }


    //显示开奖结果
    showResulet(resuletData: any, m_callback:Function, isAmin:boolean = true){
        if (resuletData == null) { return }
        let self = this
        function showPaiLong(){
            let key = Util.getImageNameFromCard(resuletData.dragon)
            self.resultPokers[0].spriteFrame = self.pokerAtlas.getSpriteFrame(key)    
        }

        function showPaiHu(){
            let key = Util.getImageNameFromCard(resuletData.tiger)
            self.resultPokers[1].spriteFrame = self.pokerAtlas.getSpriteFrame(key)
        }

        if (!isAmin){
            showPaiLong()
            showPaiHu()
            return
        }
        function m_rotateto(node:cc.Node, vec2: cc.Vec2, time:number, callback:Function, endCallBack:Function) {
            var run = cc.callFunc(function(){
                node.setScale(0.01, 1)
                if (callback != null){ callback() }
            })
    
            var endRun = cc.callFunc(function(){
                node.setScale(1, 1)
                if (endCallBack != null){ endCallBack() }
            })
            node.runAction(cc.sequence(cc.scaleBy(0, 1), cc.scaleBy(time, 0.01, 1), run , cc.scaleBy(time, 100, 1), endRun))
        }
        
        //播放龙声音
        this.tableSound.playPaiName(1, ()=>{
            self.tableSound.playDianShu(resuletData.dragon.number)
        })
        m_rotateto(self.resultPokers[0].node, new cc.Vec2(0, 90), 0.15, showPaiLong, null)
        this.scheduleOnce(()=>{
            self.tableSound.playPaiName(2, ()=> {
                
                self.tableSound.playDianShu(resuletData.tiger.number)
            })

            m_rotateto(self.resultPokers[1].node, new cc.Vec2(0, 90), 0.15, showPaiHu, ()=>{
                self.scheduleOnce(()=>{
                    self.tableSound.playerWin(resuletData.result)
                    let heNum = resuletData.result == 0 ? 3 :resuletData.result //没有对应好index 只能先这个勒
                    if (self.betArea[heNum] != null){
                        let effectName = null
                        if (resuletData.result == 0){
                            effectName = EffectName.ResultHe
                        }
                        else if (resuletData.result == 1){
                            effectName = EffectName.ResultLong
                        }
                        else {
                            effectName = EffectName.ResultHu
                        }
                        self.effectCtr.playEffectAnim(effectName, m_callback)
                        self.scheduleOnce(()=>{
                            self.tableSound.playerWinAmin(resuletData.result)
                        }, 0.2)
                    }
                }, 1.5)
            })
        }, 2)
    }

    updateResultCount(data){
        this.allCount.string = data.length
        let resCount = [0, 0, 0]
        for (const value of data) {
            resCount[value] += 1
        }
        this.heCount.string = resCount[0].toString()
        this.longCount.string = resCount[1].toString()
        this.huCount.string = resCount[2].toString()
    }

    playResultAmin(resuletData, betData, jackpotDataAdd){
        let winArea = resuletData.result == 0 ? 3 : resuletData.result
        this.curWinArea[0] = false
        this.curWinArea[winArea.toString()] = true
        super.playResultAmin(resuletData, betData, jackpotDataAdd)
    }


    //获取下注区域
    getAreaByPosMax(area){
        return this.betAreaType.He == area ? this.getRandomPosInRect(500, 20) : this.getRandomPosInRect(200, 70)
    }

    cleanTable(){
        super.cleanTable()
        for (const poker of this.resultPokers) {
            poker.node.active = false
            poker.spriteFrame = this.pokerAtlas.getSpriteFrame(this.paiBeiName)
        }
    }
}